import {
    QuiltyResourceListItem,
    QuiltyResourceListResponse,
} from "@gsx/common/src/types/http/admin/quiltyResource";
import { Api } from "../../../../../common/src/api/Api";
import ListStoreVuex from "../../../../../common/src/stores/general/ListStoreVuex";
import { Module, RegisterOptions } from "vuex-class-modules";

@Module({ generateMutationSetters: true })
export class QuiltyResourceListStore extends ListStoreVuex<QuiltyResourceListItem> {
    query: string = "";
    organizationId: string = "";

    setOrganizationId(id: string) {
        this.organizationId = id;
    }

    constructor(private readonly api: Api, options: RegisterOptions) {
        super(options);
        this.pageSize = 5;
    }

    protected async fetch(): Promise<QuiltyResourceListResponse> {
        return this.api.admin.quiltyResources.list({
            ...this.queryParams,
            sort: this.sort || "postDate",
            order: this.order,
            skip: `${this.pageSize * (this.page - 1)}`,
            take: `${this.pageSize}`,
            query: this.query,
            organizationId: this.organizationId,
        });
    }
}
